import React from "react";
import { Button, Link, cn } from "@heroui/react";
import { X } from "lucide-react";

const INTL_SITE_URL = "https://www.3chat.ai/";
const NOTICE_HEIGHT_PX = 40;

export default function IntlSiteNoticeBar() {
  const [dismissed, setDismissed] = React.useState(false);

  React.useLayoutEffect(() => {
    const height = dismissed ? "0px" : `${NOTICE_HEIGHT_PX}px`;
    document.documentElement.style.setProperty("--intl-notice-height", height);
    return () => {
      document.documentElement.style.removeProperty("--intl-notice-height");
    };
  }, [dismissed]);

  const handleDismiss = () => {
    setDismissed(true);
  };

  if (dismissed) {
    return null;
  }

  return (
    <div
      role="region"
      aria-label="国际版网站提示"
      className={cn(
        "fixed inset-x-0 top-0 z-[60] h-10 overflow-hidden",
        "bg-default-100 text-default-foreground",
      )}
    >
      <div className="grid h-full w-full grid-cols-[2.25rem_1fr_2.25rem] items-center sm:grid-cols-[2.5rem_1fr_2.5rem]">
        <span className="pointer-events-none select-none" aria-hidden />
        <div className="flex min-w-0 items-center justify-center gap-2 sm:gap-3">
          <p className="min-w-0 truncate text-center text-[11px] leading-none sm:text-xs">
            如需连接{" "}
            <span className="whitespace-nowrap">Discord</span>、
            <span className="whitespace-nowrap">Line</span>、
            <span className="whitespace-nowrap">Gmail</span>{" "}
            等更多国外渠道，可前往
          </p>
          <Button
            as={Link}
            className="h-7 min-h-7 shrink-0 px-2.5 text-[11px] font-medium sm:px-3 sm:text-xs"
            color="primary"
            href={INTL_SITE_URL}
            radius="full"
            rel="noopener noreferrer"
            target="_blank"
            variant="flat"
          >
            3Chat 国际版
          </Button>
        </div>
        <div className="flex justify-center">
          <button
            type="button"
            aria-label="关闭提示"
            className="text-default-400 hover:text-default-foreground rounded-md p-1 transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-default-100 focus-visible:outline-none"
            onClick={handleDismiss}
          >
            <X aria-hidden className="h-3.5 w-3.5" strokeWidth={2} />
          </button>
        </div>
      </div>
    </div>
  );
}
